export default function ThreeDotsVertical({ className = "" }) {
	return (
		<svg className={className} width="2" height="12" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="1" cy="1" r="1" fill="currentColor" />
			<circle cx="1" cy="6" r="1" fill="currentColor" />
			<circle cx="1" cy="11" r="1" fill="currentColor" />
		</svg>
	);
}
